import { render, staticRenderFns } from "./ModalTextConfirmation.vue?vue&type=template&id=936a88ee"
import script from "./ModalTextConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalTextConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports